// extracted by mini-css-extract-plugin
module.exports = {"button":"BoardModal_button__13b4T","wrapper":"BoardModal_wrapper__2zryI","burst":"BoardModal_burst__3372W","message":"BoardModal_message__3FOsX"};